import * as url from "../../helpers/url_helper";
import { APIClient } from "../../helpers/api_helper";

const apiClient = new APIClient();

/**
     * Valida si el usuario consultado tiene un crédito vigente
     * @param {string} documento documento del usuario ej. 12345678
     * @returns {Promise<boolean> | Error} true si el usuario tiene un crédito vigente
*/
export const handleValidateUserHasValidCredit = async (documento) => {
    try {
        let { data, status } = await apiClient.get(url.VALIDATE_HAS_VIGENT_CREDIT + "/" + documento);
        if (status !== 200) {
            return Error("No se pudo validar si el usuario tiene un crédito vigente.");
        }
        if (data.info === false) {
            return false;
        }
        return true;
    } catch (error) {
        return error?.message;
    }
}